module.exports = __webpack_public_path__ + "img/logos_visa.c76ca0d5.svg";